import React from 'react';
import WIPMessage from '@/components/errors/WIPMessage';

const ActivitiesPanelNarrow = () => (
  <WIPMessage />
);

export default ActivitiesPanelNarrow;
